import type { FormInstance } from 'antd';
import type { DefaultOptionType } from 'antd/es/select';

interface Props {
  form: FormInstance;
  formItemName: string;
  option: DefaultOptionType;
  itemDataTestId: string;
  activeItemDataTestId: string;
}

export const addDataTestIdsToSelectDropdown = ({
  form,
  option,
  itemDataTestId,
  activeItemDataTestId,
  formItemName,
}: Props) => {
  const selectedValue = form.getFieldValue(formItemName);

  const isSelected = option.value === selectedValue;

  return (
    <div data-testid={isSelected ? activeItemDataTestId : itemDataTestId}>
      {option.label}
    </div>
  );
};
